import api from '../config/axios';

const DASHBOARD_API = '/admin';

const dashboardService = {
  // Fetch main dashboard overview data
  getDashboardOverview: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard overview:', error);
      throw error;
    }
  },

  // Fetch revenue analytics data
  getRevenueAnalytics: async (dateRange = 'monthly') => {
    try {
      const response = await api.get(DASHBOARD_API + '/revenue', {
        params: { range: dateRange }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching revenue analytics:', error);
      throw error;
    }
  },

  // Fetch order analytics data
  getOrderAnalytics: async (dateRange = 'monthly') => {
    try {
      const response = await api.get(DASHBOARD_API + '/orders/analytics', {
        params: { range: dateRange }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching order analytics:', error);
      throw error;
    }
  },

  // Fetch user analytics data
  getUserAnalytics: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/users');
      return response.data;
    } catch (error) {
      console.error('Error fetching user analytics:', error);
      throw error;
    }
  },

  // Fetch device traffic data
  getDeviceTraffic: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/device-traffic');
      return response.data;
    } catch (error) {
      console.error('Error fetching device traffic:', error);
      throw error;
    }
  },

  // Fetch recent orders
  getRecentOrders: async (limit = 10) => {
    try {
      const response = await api.get(DASHBOARD_API + '/recent-orders', {
        params: { limit }
      });
      console.log('Recent orders API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching recent orders:', error);
      throw error;
    }
  },

  // Fetch top products
  getTopProducts: async (limit = 10) => {
    try {
      const response = await api.get(DASHBOARD_API + '/top-products', {
        params: { limit }
      });
      console.log('Top products API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching top products:', error);
      throw error;
    }
  },

  // Fetch vendor performance
  getVendorPerformance: async (limit = 10) => {
    try {
      const response = await api.get(DASHBOARD_API + '/vendor-performance', {
        params: { limit }
      });
      console.log('Vendor performance API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor performance:', error);
      throw error;
    }
  },

  // Fetch cart analytics
  getCartAnalytics: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/cart-analytics');
      return response.data;
    } catch (error) {
      console.error('Error fetching cart analytics:', error);
      throw error;
    }
  },

  // Fetch comprehensive dashboard data
  getComprehensiveDashboard: async () => {
    try {
      console.log('Fetching dashboard data from:', DASHBOARD_API + '/dashboard');
      const response = await api.get(DASHBOARD_API + '/dashboard');
      console.log('Dashboard API response:', response);
      return response.data;
    } catch (error) {
      console.error('Error fetching comprehensive dashboard data:', error);
      throw error;
    }
  },

  // Export dashboard data
  exportDashboardData: async (type, dateRange) => {
    try {
      const response = await api.get(DASHBOARD_API + '/export', {
        params: { type, range: dateRange },
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting dashboard data:', error);
      throw error;
    }
  },

  // Real-time data refresh methods
  refreshDashboardData: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error refreshing dashboard data:', error);
      throw error;
    }
  },

  // Get real-time orders count
  getRealTimeOrdersCount: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/orders');
      return response.data;
    } catch (error) {
      console.error('Error fetching real-time orders count:', error);
      throw error;
    }
  },

  // Get real-time revenue data
  getRealTimeRevenue: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching real-time revenue:', error);
      throw error;
    }
  },

  // Get real-time user metrics
  getRealTimeUserMetrics: async () => {
    try {
      const response = await api.get(DASHBOARD_API + '/users');
      return response.data;
    } catch (error) {
      console.error('Error fetching real-time user metrics:', error);
      throw error;
    }
  }
};

export default dashboardService;
